import { Badge, type BadgeProps } from '@radix-ui/themes'
import { Ops } from '@willie/schemas'
import { loggerMakerLabel } from '../constants'

type LoggerMakerBadgeProps = Omit<BadgeProps, 'children'> & { loggerMaker: string | null }

export const LoggerMakerBadge = ({ loggerMaker, variant = 'soft', ...badgeProps }: LoggerMakerBadgeProps) => {
  const maker = Ops.StationInstallations.loggerMakerSchema.safeParse(loggerMaker).data
  return (
    <Badge variant={variant} {...badgeProps}>
      {maker ? loggerMakerLabel[maker] : (loggerMaker ?? 'No logger maker')}
    </Badge>
  )
}
